import { Component, type ErrorInfo, type ReactNode } from "react";
import i18n from "../lib/i18n";

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Pactios OS", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <div className="module-error" role="alert">
      <h2>{i18n.t("common.errorTitle")}</h2>
      <p>{i18n.t("common.errorInfo")}</p>
      <code>{this.state.error.message}</code>
      <button type="button" className="outline-button" onClick={() => window.location.reload()}>{i18n.t("common.reload")}</button>
    </div>;
  }
}
